import { Component, OnInit, ViewChild } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';
import { ModalService } from 'ng-bootstrap-modal';
import { ExcelService } from '../../services/excel.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls: ['./generate-report.component.scss']
})
export class GenerateReportComponent implements OnInit {
  isSlide: boolean = false;
  startDateValue: Date;
  endDateValue: Date;
  ReportForm: FormGroup;
  masterSelected = false;
  checkedList: any;
  // checklist = [];
  ShowChecklist: boolean = false
  checklist = []
  Appointments = [
    { id: 1, value: 'PATIENT NAME', isSelected: false },
    { id: 2, value: 'Age', isSelected: false },
    { id: 3, value: 'E-MAIL', isSelected: false },
    { id: 4, value: 'MOBILE', isSelected: false },
    { id: 5, value: 'DOCTOR NAME', isSelected: false },
    { id: 6, value: 'APPOINTMENT STATUE', isSelected: false },
    { id: 7, value: 'DIAGNOSIS/ASSESMENT', isSelected: false },
    { id: 7, value: 'INSURER', isSelected: false },
    { id: 8, value: 'SCHEME/EMPLOYER', isSelected: false },
    { id: 9, value: 'MEDICATION DELIVERY', isSelected: false },
    { id: 10, value: 'LAB/DIAGNOSTICS', isSelected: false },
    { id: 11, value: 'REFERAL', isSelected: false },
    { id: 12, value: 'LOCATION', isSelected: false },
    { id: 13, value: 'COUPON CODE', isSelected: false },
    { id: 14, value: 'amount paid', isSelected: false },
    { id: 15, value: 'transaction id', isSelected: false },
    { id: 16, value: 'invoice number', isSelected: false },
    {id: 17, value: 'appointmentid', isSelected: false}
  ];
  Patients = [
    { id: 8, value: 'Patient Name', isSelected: false },
    { id: 8, value: 'Patient Age', isSelected: false },
    { id: 8, value: 'id', isSelected: false },
    { id: 8, value: 'National Id', isSelected: false },
    { id: 8, value: 'DOB', isSelected: false },
    { id: 8, value: 'Email', isSelected: false },
    { id: 8, value: 'Mobile', isSelected: false },
    { id: 8, value: 'Address', isSelected: false },
    { id: 8, value: 'City', isSelected: false },
    { id: 8, value: 'Created Date', isSelected: false },
    { id: 8, value: 'Employer Info', isSelected: false },
    { id: 8, value: 'Insurer Info', isSelected: false },
    { id: 8, value: 'Verified account', isSelected: false },
    { id: 8, value: 'FamilySize', isSelected: false },
  ];
  ActiveSubscription = [
    { id: 8, value: 'Name', isSelected: false },
    { id: 8, value: 'Programfor', isSelected: false },
    { id: 8, value: 'Programtype', isSelected: false },
    { id: 8, value: 'Agerestriction', isSelected: false },
    { id: 8, value: 'Consultationcount', isSelected: false },
    { id: 8, value: 'Createdby', isSelected: false },
    { id: 8, value: 'Createddate', isSelected: false },
    { id: 8, value: 'Credit', isSelected: false },
    { id: 8, value: 'Creditapply', isSelected: false },
    { id: 8, value: 'Members', isSelected: false },
    { id: 8, value: 'Partnerid', isSelected: false },
    { id: 8, value: 'Plancost', isSelected: false },
    { id: 8, value: 'Planyears', isSelected: false },
  ];
  NewSubscription = [
    { id: 8, value: 'Name', isSelected: false },
    { id: 8, value: 'Programfor', isSelected: false },
    { id: 8, value: 'Programtype', isSelected: false },
    { id: 8, value: 'Agerestriction', isSelected: false },
    { id: 8, value: 'Consultationcount', isSelected: false },
    { id: 8, value: 'Createdby', isSelected: false },
    { id: 8, value: 'Createddate', isSelected: false },
    { id: 8, value: 'Credit', isSelected: false },
    { id: 8, value: 'Creditapply', isSelected: false },
    { id: 8, value: 'Members', isSelected: false },
    { id: 8, value: 'Partnerid', isSelected: false },
    { id: 8, value: 'Plancost', isSelected: false },
    { id: 8, value: 'Planyears', isSelected: false },
  ];
  PurchasedSubscription = [
    { id: 8, value: 'Name', isSelected: false },
    { id: 8, value: 'Programfor', isSelected: false },
    { id: 8, value: 'Programtype', isSelected: false },
    { id: 8, value: 'Agerestriction', isSelected: false },
    { id: 8, value: 'Consultationcount', isSelected: false },
    { id: 8, value: 'Createdby', isSelected: false },
    { id: 8, value: 'Createddate', isSelected: false },
    { id: 8, value: 'Credit', isSelected: false },
    { id: 8, value: 'Creditapply', isSelected: false },
    { id: 8, value: 'Members', isSelected: false },
    { id: 8, value: 'Partnerid', isSelected: false },
    { id: 8, value: 'Plancost', isSelected: false },
    { id: 8, value: 'Planyears', isSelected: false },
    { id: 8, value: 'PurchaseCount', isSelected: false },
    { id: 8, value: 'ActivationDate', isSelected: false },
    { id: 8, value: 'ActivationTime', isSelected: false },
    { id: 8, value: 'DeactivationDate', isSelected: false },
    { id: 8, value: 'DeactivationTime', isSelected: false },
  ];
  SubscriptionUtilization = [

  ];
  Subscriptionpayment = [
    { id: 8, value: 'Customer Name', isSelected: false },
    { id: 8, value: 'Customer Phone', isSelected: false },
    { id: 8, value: 'Customer Country', isSelected: false },
    { id: 8, value: 'Customer City', isSelected: false },
    { id: 8, value: 'Customer Zip', isSelected: false },
    { id: 8, value: 'Transaction Token', isSelected: false },
    { id: 8, value: 'Customer Credit', isSelected: false },
    { id: 8, value: 'Payment Type', isSelected: false },
    { id: 8, value: 'Currency', isSelected: false },
    { id: 8, value: 'Transaction Amount', isSelected: false },
    { id: 8, value: 'Name', isSelected: false },
    { id: 8, value: 'Programfor', isSelected: false },
    { id: 8, value: 'Programtype', isSelected: false },
    { id: 8, value: 'Credit', isSelected: false },
    { id: 8, value: 'Creditapply', isSelected: false },
    { id: 8, value: 'Members', isSelected: false },
    { id: 8, value: 'Plancost', isSelected: false },
    { id: 8, value: 'Planyears', isSelected: false },
  ];
  constructor(private router: Router, private fb: FormBuilder, private http: HttpClient, private ngxService: NgxUiLoaderService, private _analyticsService: AnalyticsService, private modalService: ModalService, private excelService: ExcelService, private CommonModule: CommonModule) {


    this.startDateValue = new Date();
    this.endDateValue = new Date();
    this.ReportForm = fb.group({
      type: [0, [
        Validators.required
      ]],
      startDate: [this.startDateValue, [
        Validators.required
      ]],
      endDate: [this.endDateValue, [
        Validators.required
      ]]
    });
  }

  ngOnInit() {

  }
  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }



  submitReportForm(ReportForm: FormGroup) {
    let startDate = ReportForm.value.startDate
    let endDate = ReportForm.value.endDate
    if (ReportForm.value.type == 0) {
      alert('Please select report type')
    } else {
      if (!(startDate.getTime() <= endDate.getTime())) {
        alert('Start date should be less then End date')
      } else {
        startDate = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate()
        endDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate();
        if (ReportForm.value.type == 1) {
          this._analyticsService.getAllappointmentsByDate(startDate, endDate, this.checkedList).subscribe((data) => {
            if (data['data']) {
              this.excelService.exportAsExcelFile(data['data'], "appointments_report");
            } else {
              alert('No record found')
            }
          }, (err) => {
            alert(err)
          });
        }
        if (ReportForm.value.type == 2) {
          this._analyticsService.getAllPatientsByDate(startDate, endDate, this.checkedList).subscribe((data) => {
            if (data['data']) {


              this.excelService.exportAsExcelFile(data['data'], "patients_report");
            } else {
              alert('No record found')
            }
          }, (err) => {
            alert(err)
          });
        }
        if (ReportForm.value.type == 3) {
          this._analyticsService.getActiveSubscriptionReport(ReportForm.value.startDate, ReportForm.value.endDate, this.checkedList).subscribe((data) => {
            if (data['response']) {
              this.excelService.exportAsExcelFile(data['response'], "Active_Subscription_report");
            } else {
              alert('No record found')
            }
          }, (err) => {
            alert(err)
          });
        }

        if (ReportForm.value.type == 4) {
          this._analyticsService.getNewSubscriptionReport(ReportForm.value.startDate, ReportForm.value.endDate, this.checkedList).subscribe((data) => {
            if (data['response']) {
              this.excelService.exportAsExcelFile(data['response'], "New_Subscription_report");
            } else {
              alert('No record found')
            }
          }, (err) => {
            alert(err)
          });
        }
        if (ReportForm.value.type == 5) {
          this._analyticsService.getPurchasedSubscriptionReport(ReportForm.value.startDate, ReportForm.value.endDate, this.checkedList).subscribe((data) => {
            if (data['response']) {
              this.excelService.exportAsExcelFile(data['response'], "Purcahsed_Subscription_report");
            } else {
              alert('No record found')
            }
          }, (err) => {
            alert(err)
          });
        }
        if (ReportForm.value.type == 6) {
          // utilization report.
        }
        if (ReportForm.value.type == 7) {
          this._analyticsService.getSubscriptionTransactionalReport(ReportForm.value.startDate, ReportForm.value.endDate, this.checkedList).subscribe((data) => {
            if (data['response']) {
              this.excelService.exportAsExcelFile(data['response'], "Subscription_Transactional_report");
            } else {
              alert('No record found')
            }
          }, (err) => {
            alert(err)
          });
        }
        if (ReportForm.value.type == 8) {
          // Auditr Log report.
        }
      }
    }

  }

  //Get selected item in admin report
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i].value);
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }

  selectType() {
    if (this.ReportForm.value.type != 0) {
      this.ShowChecklist = true
      this.checklist = []
      if (this.ReportForm.value.type == 1) {
        for (var i of this.Appointments) {
          this.checklist.push(i)
        }
      } if (this.ReportForm.value.type == 2) {
        for (var i of this.Patients) {
          this.checklist.push(i)
        }
      } if (this.ReportForm.value.type == 3) {
        for (var i of this.ActiveSubscription) {
          this.checklist.push(i)
        }
      } if (this.ReportForm.value.type == 4) {
        for (var i of this.NewSubscription) {
          this.checklist.push(i)
        }
      } if (this.ReportForm.value.type == 5) {
        for (var i of this.PurchasedSubscription) {
          this.checklist.push(i)
        }
      } if (this.ReportForm.value.type == 6) {

      } if (this.ReportForm.value.type == 7) {
        for (var i of this.Subscriptionpayment) {
          this.checklist.push(i)
        }
      } if (this.ReportForm.value.type == 8) {

      }
    } else {
      this.ShowChecklist = false
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/admin/generate-report/generate-report.component.ts